import React from 'react';

const DefaultError: React.FC<{ error: string; onRetry?: () => void }> = ({ error, onRetry }) => (
  <div className="flex flex-col items-center justify-center p-8 text-center">
    <div className="text-red-500 text-6xl mb-4">⚠️</div>
    <h3 className="text-lg font-semibold text-on-surface mb-2">Wystąpił błąd</h3>
    <p className="text-on-surface/70 mb-4">{error}</p>
    {onRetry && (
      <button
        onClick={onRetry}
        className="bg-primary text-on-primary px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors"
      >
        Spróbuj ponownie
      </button>
    )}
  </div>
);

export default DefaultError;
